/* eslint-disable */
import { AEMManifest } from './manifest-interface';

const meta: AEMManifest = require('./../oneweb.js');
const NAME = `${meta.aemComponentConfig.productPrefix}-${meta.aemComponentConfig.tagNameWithoutPrefix}`

/**
* vue needs to know the asset uri url to download the chunks
*/
export const initAssetServer = () => { 
  if ((window as any).aemNamespace) {
    // AEM MOCK SERVER
    if((window as any).aemNamespace.environmentVariables) {
      if ((window as any).aemNamespace.environmentVariables[NAME]) {
        __webpack_public_path__ = `${(window as any).aemNamespace.environmentVariables[NAME].__webpack_public_path__}`
      }
      // AEM servers
      if ((window as any).aemNamespace.environmentVariables.assetUri && !(window as any).aemNamespace.environmentVariables[NAME]) {
        __webpack_public_path__ = `${(window as any).aemNamespace.environmentVariables.assetUri}/${NAME}/`
      }
      if ((window as any).aemNamespace.environmentVariables.stage !== 'prod') {
        console.log('__webpack_public_path__ ' + NAME, __webpack_public_path__)
      }
    }
  }
};
